module.exports = __webpack_public_path__ + "static/media/map-right-nav.be0db3ef.svg";